import axios from "axios";
import React, { Component } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
//@ts-ignore
import FileViewer from "react-file-viewer";
//@ts-ignore
import uuid from "react-uuid";
import moment from "moment";
import AxiosConfig from "../../../../utilities/AxiosConfig";
import IconBuilder from "../../../../utilities/iconBuilder/IconBuilder";
import reggie from "../../../../utilities/Reggie";
import snackBar from "../../../../utilities/snackBar/SnackBar";
import FileTypes from "./FileTypes";
import directoryBuilder from "src/utilities/directoryBuilder";
import DocAnnotator from "./DocAnnotator/DocAnnotator";
import "./DocUploader.css";
import FileNameError from "./FileNameError";

interface DocUploaderProps {
    manageParentState: Function;
    manageGrandparentState?: Function;
    timelineId: number;
    contextUserId: string | number;
    refreshTimeline: Function;
    timelineEndpoint: string;
    timelineType: string;
    storageLocation: string;
    containerName: string;
    fileStoreLocationId: string;
    uploadOnDrop?: boolean;
}

type DocUploaderTypes = {
    files: Array<FileTypes> | [];
    uploading: boolean;
    drag: boolean;
    annotationDex: number;
    fileNameError: { err: boolean; fileName: string };
};

class DocUploader extends Component<DocUploaderProps, DocUploaderTypes> {
    dropRef: any = React.createRef();
    dragCounter = 0;
    listenInterval: any;
    uploadDex = 0;

    state = {
        files: [],
        uploading: false,
        drag: false,
        annotationDex: -1,
        fileNameError: { err: false, fileName: "" }
    };

    manageState = (keys: Array<{ key: string; value?: any }>) => {
        let state: any = this.state;
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value;
            } else {
                state[keys[i].key] = !state[keys[i].key];
            }
        }
        this.setState(state);
    };

    componentDidMount() {
        let div: any = this.dropRef.current;
        div.addEventListener("dragenter", this.handleDragIn);
        div.addEventListener("dragleave", this.handleDragOut);
        div.addEventListener("dragover", this.handleDrag);
        div.addEventListener("drop", this.handleDrop);
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        let div: any = this.dropRef.current;
        div.removeEventListener("dragenter", this.handleDragIn);
        div.removeEventListener("dragleave", this.handleDragOut);
        div.removeEventListener("dragover", this.handleDrag);
        div.removeEventListener("drop", this.handleDrop);
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event: { keyCode: number }) => {
        if (event.keyCode === 13 && this.state.files.length > 0) {
            this.upload();
        }
    };

    handleDrag = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragIn = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.manageState([{ key: "drag", value: true }]);
        }
    };

    handleDragOut = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.manageState([{ key: "drag", value: false }]);
        }
    };

    handleDrop = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        this.manageState([{ key: "drag", value: false }]);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            this.fileSelectedHandler({ target: { files: e.dataTransfer.files } });
            e.dataTransfer.clearData();
            this.dragCounter = 0;
        }
    };

    upload = () => {

        const file: FileTypes = this.state.files[this.uploadDex]

        if (file.displayName.replace(/\.[^/.]+$/, "").length > 50) {
            this.manageState([{ key: "fileNameError", value: { err: true, fileName: `${file.displayName.replace(/\.[^/.]+$/, "")}` } }])
            this.purgeAll()
            console.log("file too long")
        } else {

            if (!this.state.uploading) {
                // this.setState({ uploading: true })
                this.manageState([{ key: "uploading", value: true }])
            }

            if (file) {
                this.fileUploadHandler(file)
            } else {
                this.purgeAll()
                this.uploadDex = 0
                setTimeout(() => {
                    this.props.refreshTimeline()
                    this.props.manageParentState([{ key: "uploadDocument", value: false }])
                }, 500)
            }
        }

    }

    handleUploadProgress = (id: string, progress: number) => {
        let elem = document.getElementById(`${id}-file-upload-progress-marker`)
        if (elem) {
            elem.innerHTML = `${progress}%`
        }
    }

    purgeAll = () => {
        // this.setState({
        //     files: [],
        //     uploading: false,
        //     drag: false,
        // })
        this.manageState([{ key: "files", value: [] }, { key: "uploading", value: false }, { key: "drag", value: false }])
    }

    purgeSingle = (id: string) => {

        let temp: Array<FileTypes> = this.state.files
        let elem = document.getElementById(id)

        if (elem) {
            elem.classList.add("FileFadeOut")
            setTimeout(() => {
                //@ts-ignore
                elem.style.display = "none"
            }, 500)
        }

        for (let i = 0; i < temp.length; i++) {
            if (id === temp[i].elementId) {
                temp[i].purged = true
            }
        }

        // this.setState({ files: temp })
        this.manageState([{ key: "files", value: temp }])

    }

    buildRelativePath = (name: string) => {
        const id = this.props.timelineId
        return `${directoryBuilder.calculateDirectory(id)}/${id}_${Date.now()}_${name.replace(/\s/g, "")}`
    }

    fileSelectedHandler = (event: any) => {
        let files: Array<FileTypes> = this.state.files
        if (event.target.files && event.target.files[0]) {
            for (let i = 0; i < event.target.files.length; i++) {
                let file = event.target.files[i];
                let infoId = this.props.timelineId
                let date = Date.now()
                let regex = /(?:\.([^.]+))?$/
                //@ts-ignore
                let extension = regex.exec(file.name)[1]
                let path = `${infoId}_${date}`
                files.push(
                    {
                        file: URL.createObjectURL(file),
                        blob: file,
                        extension: extension,
                        path: path,
                        loadingFile: false,
                        displayName: reggie.joinString(file.name),
                        elementId: uuid(),
                        purged: false,
                        noteText: null
                    }
                )
            }

            setTimeout(() => {
                // this.setState({ files: files })
                this.manageState([{ key: "files", value: files }])
                if (this.props.uploadOnDrop) {
                    setTimeout(() => {
                        this.upload()
                    }, 500)
                }
            }, 500)
        }
    }

    fileUploadHandler = (file: FileTypes) => {

        if (!file.purged) {

            const blob: any = file.blob
            const path: any = file.path
            const name = reggie.joinString(blob.name)
            const config = AxiosConfig.configValue()
            const elementId = file.elementId

            if (blob && path) {
                // this.handleUploadProgress(fileId, 0)
                const relativePath = this.buildRelativePath(blob.name)
                let fd = new FormData()
                fd.append('File', blob, blob.name)
                fd.append("Json",
                    JSON.stringify({
                        // RelativePathAndName: `${path}.${file.extension}`,
                        RelativePathAndName: relativePath,
                        storageLocation: this.props.storageLocation,
                        ContainerName: this.props.containerName
                    })
                )
                axios.request({
                    method: "post",
                    url: process.env.REACT_APP_IMG_API_URL + "/api/file/secure",
                    data: fd,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        Accept: "application/json",
                        Authorization: "Bearer " + config.headers.authorization.split(" ")[1]
                    },
                    maxContentLength: 10000000,
                    //@ts-ignore
                    maxBodyLength: 10000000,
                    onUploadProgress: (ProgressEvent: any) => {
                        let progress = Math.round(ProgressEvent.loaded / ProgressEvent.total * 100)
                        if (progress >= 10) {
                            this.handleUploadProgress(elementId, progress - 10)
                        }
                    }
                }).then(() => {
                    this.fileAttachToHandler(name, relativePath)
                }).catch(() => {
                    snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
                    this.purgeAll()
                    this.uploadDex = 0
                })
            } else {
                snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
                this.purgeAll()
                this.uploadDex = 0
            }

        } else {
            this.uploadDex++
            this.upload()
        }
    }

    fileAttachToHandler = (name: string, relativePath: string) => {

        //@ts-ignore
        this.handleUploadProgress(this.state.files[this.uploadDex].elementId, 95)

        let requestBody = {
            AttachmentId: null,
            AttachedToTypeID: "21",
            AttachmentTypeID: "3",
            AttachedToID: this.props.timelineId,
            Name: name.replace(/\.[^/.]+$/, ""),
            ImageFileStoreLocationID: this.props.fileStoreLocationId,
            RelativePath: `/${relativePath}`,
            Comments: null,
            CreatedDate: moment().format(),
            CreatedBy: parseInt(this.props.contextUserId + ""),
            ModifyDate: moment().format(),
            ModifiedBy: parseInt(this.props.contextUserId + ""),
            DeletedDate: null,
            DeletedBy: null,
            DisabledDate: null,
            DisabledBy: null,
            Option1: null,
            Option2: moment().format(),
            Option3: null,
            Option4: null,
            Status: 0
        }

        axios.post(process.env.REACT_APP_API_URL + "/api/Data/AddOrUpdateAttachment", requestBody, AxiosConfig.configValue("min"))
            .then((res) => {
                //@ts-ignore
                this.createTimelineItem(res.data.AttachmentID, name, this.state.files[this.uploadDex].elementId)
            }).catch(err => {
                //console.log(err)
                snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
                this.purgeAll()
                this.uploadDex = 0
            })
    }

    createTimelineItem = (attachmentId: number, name: string, elementId: string) => {

        let rb = {}

        const date = new Date();
        let offset = date.getTimezoneOffset()

        if (this.props.timelineType === "workComp") {
            rb = {
                IncidentTimelineId: null,
                IncidentId: this.props.timelineId,
                IncidentTimelineTypeId: 1,
                TimelineTitle: name,
                TimelineDateUTC: moment().add(offset, "minutes").format(),
                LinkedToId: attachmentId,
                CreatedDateUTC: moment().add(offset, "minutes").format(),
                CreatedBy: this.props.contextUserId,
                DeletedDateUTC: null,
                DeletedBy: null,
                DisabledDateUTC: null,
                DisabledBy: null,
                //@ts-ignore
                NoteText: this.state.files[this.uploadDex].noteText,
                IsLocked: false
            }
        } else {
            rb = {
                EmployeeReviewTimelineId: null,
                EmployeeReviewId: this.props.timelineId,
                EmployeeReviewTimelineTypeId: 1,
                TimelineTitle: name,
                TimelineDateUTC: moment().add(offset, "minutes").format(),
                LinkedToId: attachmentId,
                CreatedDateUTC: moment().add(offset, "minutes").format(),
                CreatedBy: this.props.contextUserId,
                DeletedDateUTC: null,
                DeletedBy: null,
                DisabledDateUTC: null,
                DisabledBy: null,
                //@ts-ignore
                NoteText: this.state.files[this.uploadDex].noteText,
                IsLocked: true
            }
        }

        axios.post(process.env.REACT_APP_API_URL + this.props.timelineEndpoint, rb, AxiosConfig.configValue("min"))
            .then(() => {
                this.handleUploadProgress(elementId, 100)
                let elem = document.getElementById(elementId)
                if ((this.state.files.length - 1 > this.uploadDex) && elem) {
                    this.uploadDex++
                    elem.classList.add("FileSlideOut")
                    setTimeout(() => {
                        //@ts-ignore
                        elem.style.display = "none"
                        this.upload()
                    }, 500)
                } else {
                    this.purgeAll()
                    this.uploadDex = 0
                    setTimeout(() => {
                        this.props.refreshTimeline()
                        this.props.manageParentState([{ key: "uploadDocument", value: false }])
                        snackBar({ type: "success", text: "File uploaded successfully", timeout: 3000 })
                    }, 500)//to match animation timeout
                }
            }).catch(err => {
                //console.log(err)
                snackBar({ type: "error", text: "Encountered an error during the file upload process", timeout: 3000 })
                this.purgeAll()
                this.uploadDex = 0
            })
    }

    canUpload = () => {
        let count = 0
        for (let i = 0; i < this.state.files.length; i++) {
            //@ts-ignore
            if (!this.state.files[i].purged) {
                count++
            }
        }
        return count > 0
    }

    handleExit = () => {
        if (this.props.manageGrandparentState) {
            this.props.manageGrandparentState([{ key: "largeTimeline", value: false }, { key: "defaultDocUploaderOpen", value: false }])
        }
        this.props.manageParentState([{ key: "uploadDocument", value: false }])
    }

    render() {

        const state = this.state
        const files = state.files
        const canUpload = this.canUpload()
        console.log(state)

        return (
            <div className="DocUploader">
                {!state.fileNameError.err && <Modal id={`doc-uploader-modal-faded-${state.annotationDex > -1 ? "true" : "false"}`}
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size="xl"
                >
                    <Modal.Header>
                        <div className="DocUploaderModalHeader">
                            <p>Upload files</p>
                            {/* <div className="DocUploaderAnnotation">
                                <div className="DocUploaderAnnotationTitleWrapper">
                                    <div className="DocUploaderAnnotationTitleWrapperRight">
                                        <FormControl
                                            placeholder={"Annotation"}
                                            onChange={this.handleChange}
                                            value={this.state.annotation}
                                        />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="DocUploaderModalBody" ref={this.dropRef}>
                            {files.length === 0 && <div className="DocUploaderModalBodySupportedFileTypes">
                                <p>Supported file types:</p>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"png"}
                                        size={32}
                                    />
                                    <p>Images: png, jpeg, gif, bmp, including 360-degree images</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"pdf"}
                                        size={32}
                                    />
                                    <p>pdf</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"csv"}
                                        size={32}
                                    />
                                    <p>csv</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"xlsx"}
                                        size={32}
                                    />
                                    <p>xlsx</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"docx"}
                                        size={32}
                                    />
                                    <p>docx</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"mp4"}
                                        size={32}
                                    />
                                    <p>Video: mp4, webm</p>
                                </div>
                                <div className="DocUploaderModalBodySupportedFileType">
                                    <IconBuilder
                                        extension={"mp3"}
                                        size={32}
                                    />
                                    <p>Audio: mp3</p>
                                </div>
                            </div>}
                            {files.length === 0 && <div className="DocUploaderBackground">
                                <span className="material-icons" id="doc-uploader-background">snippet_folder</span>
                                <p>Drop files to upload here.</p>
                            </div>}
                            {/* {this.state.loadingFile && <Spinner id="loading-file-spinner" animation="border" />} */}
                            <div className="DocUploderFilePreviewsWrapper">
                                {files.map((file: FileTypes, index: number) =>
                                    <div className="DocUploderFilePreview" id={file.elementId} key={index}>
                                        <div className="DocUploderFilePreviewHeader">
                                            <div className="DocUploderFilePreviewHeaderLeft">
                                                <div className="DocUploderFilePreviewFileIcon">
                                                    <IconBuilder
                                                        extension={file.extension}
                                                        size={48}
                                                    />
                                                </div>
                                                <div className="DocUploderFilePreviewTitle">
                                                    <p>{file.displayName}</p>
                                                </div>
                                            </div>
                                            <div className="DocUploderFilePreviewHeaderRight">
                                                {!this.state.uploading && <div className="DocUploderFilePreviewHeaderAddAnnotation">
                                                    <span className="material-icons" onClick={() => this.manageState([{ key: "annotationDex", value: index }])}>sticky_note_2</span>
                                                </div>}
                                                {!this.state.uploading && <div className="DocUploderFilePreviewHeaderPurgeFile">
                                                    <span className="material-icons" onClick={() => this.purgeSingle(file.elementId)}>delete</span>
                                                </div>}
                                                {this.state.uploading && <div className="FileUploadProgress">
                                                    <p id={`${file.elementId}-file-upload-progress-marker`}>0%</p>
                                                </div>}
                                            </div>
                                        </div>
                                        <FileViewer
                                            fileType={file.extension}
                                            filePath={file.file}
                                            errorComponent={<div></div>}
                                            onError={() => null}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DocUploaderModalFooter">
                            {!this.state.uploading && <Button variant="secondary" onClick={() => this.handleExit()}>Back</Button>}
                            <div className="DocFileUploadWrapper">
                                {this.state.uploading && <Spinner id="doc-uploader-uploading-spinner" animation="border" />}
                                {!this.state.uploading && <div className="DocUploaderChoseFileWrapper">
                                    <label htmlFor="ChooseFile" className="doc-file-upload">
                                        <span className="material-icons">attach_file</span>
                                    </label>
                                    <input id="ChooseFile" type="file" multiple onChange={this.fileSelectedHandler} />
                                </div>}
                                {canUpload && !this.state.uploading && <span id="doc-uploader-purge-btn" onClick={() => this.purgeAll()} className="material-icons">clear</span>}
                                {canUpload && !this.state.uploading && <span id="doc-uploader-upload-btn" onClick={() => this.upload()} className="material-icons">file_upload</span>}
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {state.annotationDex > -1 &&
                    <DocAnnotator
                        manageParentState={this.manageState}
                        files={files}
                        annotationDex={state.annotationDex}
                    />}
                {state.fileNameError.err &&
                    <FileNameError
                        text={state.fileNameError.fileName}
                        manageParentState={this.manageState}
                    />}
            </div>
        )
    }
}

export default DocUploader